function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import { message } from 'antd';
import AlertMessage from "../alert-message";
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
var IglooMessage = {};
IglooMessage.success = function (content, duration) {
  switch (_typeof(content)) {
    case 'string':
      return message.success({
        className: 'iglooform-global-message',
        content: /*#__PURE__*/_jsx(AlertMessage, {
          type: "success",
          message: content
        }),
        icon: /*#__PURE__*/_jsx("div", {}),
        duration: duration === undefined ? 3 : duration
      });
    default:
      return message.success({
        className: 'iglooform-global-message',
        content: content,
        icon: /*#__PURE__*/_jsx("div", {}),
        duration: duration === undefined ? 3 : duration
      });
  }
};
IglooMessage.error = function (content, duration) {
  switch (_typeof(content)) {
    case 'string':
      return message.error({
        className: 'iglooform-global-message',
        content: /*#__PURE__*/_jsx(AlertMessage, {
          type: "error",
          message: content
        }),
        icon: /*#__PURE__*/_jsx("div", {}),
        duration: duration === undefined ? 3 : duration
      });
    default:
      return message.error({
        className: 'iglooform-global-message',
        content: content,
        icon: /*#__PURE__*/_jsx("div", {}),
        duration: duration === undefined ? 3 : duration
      });
  }
};
IglooMessage.warning = function (content, duration) {
  switch (_typeof(content)) {
    case 'string':
      return message.warning({
        className: 'iglooform-global-message',
        content: /*#__PURE__*/_jsx(AlertMessage, {
          type: "warning",
          message: content
        }),
        icon: /*#__PURE__*/_jsx("div", {}),
        duration: duration === undefined ? 3 : duration
      });
    default:
      return message.warning({
        className: 'iglooform-global-message',
        content: content,
        icon: /*#__PURE__*/_jsx("div", {}),
        duration: duration === undefined ? 3 : duration
      });
  }
};
IglooMessage.info = function (content, duration) {
  switch (_typeof(content)) {
    case 'string':
      return message.info({
        className: 'iglooform-global-message',
        content: /*#__PURE__*/_jsx(AlertMessage, {
          type: "info",
          message: content
        }),
        icon: /*#__PURE__*/_jsx("div", {}),
        duration: duration === undefined ? 3 : duration
      });
    default:
      return message.info({
        className: 'iglooform-global-message',
        content: content,
        icon: /*#__PURE__*/_jsx("div", {}),
        duration: duration === undefined ? 3 : duration
      });
  }
};
export default IglooMessage;